// extracted by mini-css-extract-plugin
module.exports = {"root":"ContactsScreen_root__1YrQv","titleCol":"ContactsScreen_titleCol__2prXR","contentCol":"ContactsScreen_contentCol__3Agm-"};
    if(module.hot) {
      // 1586964019089
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  